import { render, staticRenderFns } from "./sfz.vue?vue&type=template&id=6ccf1b6c&scoped=true"
import script from "./sfz.vue?vue&type=script&lang=js"
export * from "./sfz.vue?vue&type=script&lang=js"
import style0 from "./sfz.vue?vue&type=style&index=0&id=6ccf1b6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccf1b6c",
  null
  
)

export default component.exports